import PropTypes from 'prop-types'
import { Link } from 'react-router'

import IconLink from 'components/Shared/IconLink/Index'
import Tooltip from 'components/Shared/Tooltip/Index'

const ClearFiltersIcon = ({ clearUrl, tooltipText }) => {
  const tooltipId = 'clearFilterIcon'
  return (
    <Link to={clearUrl}>
      <IconLink
        iconName='icon-clear-16'
        data-tooltip-content={tooltipText}
        data-tooltip-id={tooltipId}
      />
      <Tooltip id={tooltipId} />
    </Link>
  )
}

ClearFiltersIcon.propTypes = {
  clearUrl: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired,
  ]),
  tooltipText: PropTypes.string,
}

export default ClearFiltersIcon
